import React from 'react';

import language from '../../../assets/languages/language';

function Flagged({ flaggedQuestion, className, onClick }) {
  return (
    <span
      className={`up tooltip-hover-questions quiz-flag ${className || ''}`}
      onClick={onClick}
    >
      {flaggedQuestion ? (
        <div className='tootip_box'>{language.LC().UNFLAG_THIS_QUESTION}</div>
      ) : (
        <div className='tootip_box'>{language.LC().FLAG_THIS_QUESTION}</div>
      )}
      <i
        className={
          flaggedQuestion
            ? `fa fa-flag mark-action-btn`
            : `fa fa-flag-o mark-action-btn`
        }
      >
        {' '}
      </i>
    </span>
  );
}

export default Flagged;



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/Flagged.jsx